import requests from '../../requests'

export default {
  get () {
    return requests.get('finance/ledger')
  }
}
